import { ReflagUser } from "../types/ReflagUser";

export const REFLAG_ORG_ID = "or3fo84G0xFr4D";

/** Keep employee activity out of customer accounts in production. */
export function allowEmployeeTracking(
  environment: string,
  user?: Pick<ReflagUser, "email" | "isReflagAdmin"> | null,
  orgId?: string,
): boolean {
  const isEmployee =
    user?.isReflagAdmin ||
    user?.email.toLowerCase().endsWith("@reflag.com") ||
    user?.email.toLowerCase().endsWith("@bucket.co");

  return environment !== "production" || !isEmployee || orgId === REFLAG_ORG_ID;
}
